import { render, staticRenderFns } from "./PortfolioScenarioNavigation.vue?vue&type=template&id=10bd2818"
import script from "./PortfolioScenarioNavigation.vue?vue&type=script&lang=ts"
export * from "./PortfolioScenarioNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports